import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=0bfb890a&scoped=true&"
import script from "./OurServices.vue?vue&type=script&lang=js&"
export * from "./OurServices.vue?vue&type=script&lang=js&"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=0bfb890a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb890a",
  null
  
)

export default component.exports